import React from "react";
import ReactDOM from "react-dom/client";
import Approuter from "./Routes/Approuter";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/line-awesome.min.css";
import "./assets/scss/main.scss";
import "./assets/css/material.css";
import setupAxiosInterceptors from './axiosInterceptor'; // Import the interceptor setup
import { clearStaleSensitiveUserData } from './utils/AuthUtils';
// import { Amplify } from 'aws-amplify';
// import awsmobile from './aws-exports';

// Call the interceptor setup when the app starts
setupAxiosInterceptors();
// Drop a user record cached before credential fields were removed from it
clearStaleSensitiveUserData();
// Amplify.configure(awsmobile);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Approuter />
  </>
);
